<template>
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
       viewBox="0 0 1280 1280" style="enable-background:new 0 0 1280 1280;" xml:space="preserve">
    <metadata>
      Created by potrace 1.15, written by Peter Selinger 2001-2017
    </metadata>
    <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" vector-effect="non-scaling-stroke">
      <path d="M3387 12292 l-507 -507 508 -508 507 -507 508 508 507 507 -508 508
        -507 507 -508 -508z"/>
      <path d="M4282 9913 l-501 -508 503 -502 c277 -277 508 -503 512 -503 5 0 236
        227 514 505 l505 505 -505 505 c-278 278 -510 505 -516 505 -5 0 -236 -228
        -512 -507z"/>
      <path d="M6869 5232 l-756 -3947 -1666 -3 -1667 -2 -5 22 c-3 13 -57 298 -120
        633 -146 780 -1182 6302 -1281 6826 -40 218 -74 399 -74 403 0 3 -293 6 -650
        6 l-650 0 5 -22 c2 -13 27 -144 54 -293 125 -677 399 -2159 461 -2495 27 -146
        81 -436 119 -645 167 -906 295 -1599 341 -1845 27 -146 81 -436 119 -645 39
        -209 115 -623 170 -920 146 -792 377 -2041 403 -2183 l22 -122 2751 0 2751 0
        97 517 c105 560 336 1789 747 3978 468 2490 576 3068 725 3860 80 429 149 790
        152 803 l5 22 -648 0 -649 0 -756 -3948z"/>
      <path d="M3687 7543 c-4 -3 -7 -318 -7 -700 l0 -693 700 0 700 0 -2 698 -3
        697 -691 3 c-380 1 -694 -1 -697 -5z"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "DisposalIcon"
}
</script>

<style scoped>

</style>